import './IconHeartLine.css';
import React from 'react';
const IconHeart = _ref => {
  let {
    width = 20,
    height = 20,
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: `${className} ${styles}`,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16.092 9.206L10 15.196l-6.091-5.99a2.997 2.997 0 0 1-.001-4.299A3.168 3.168 0 0 1 6.143 4c.846 0 1.64.322 2.233.905l.22.217L10 6.507l1.405-1.385.217-.215A3.166 3.166 0 0 1 13.857 4c.846 0 1.64.322 2.235.906a3.002 3.002 0 0 1 0 4.3m1.402-5.726A5.178 5.178 0 0 0 13.857 2a5.18 5.18 0 0 0-3.637 1.48l-.22.218-.22-.218A5.178 5.178 0 0 0 6.143 2a5.175 5.175 0 0 0-3.636 1.48 4.997 4.997 0 0 0 0 7.152L10 18l7.494-7.368a4.999 4.999 0 0 0 0-7.152"
  }));
};
const styles = "sj7n6cd";
export default IconHeart;